// extracted by mini-css-extract-plugin
export var bottomRightDock = "_24-0";